/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Select from "../Select";
import { CreateContract, EditContract, GetAllUsers } from "../../API/Pins";
import Input from "../Input";
import DatePicker from "react-datepicker";
import { utcToTime } from "../../utils/moment";
import { NotificationManager } from "react-notifications";

const cityList = [
  {
    "id": 28,
    "province_name": "آذربایجان شرقی"
  },
  {
    "id": 16,
    "province_name": "آذربایجان غربی"
  },
  {
    "id": 19,
    "province_name": "اردبیل"
  },
  {
    "id": 13,
    "province_name": "اصفهان"
  },
  {
    "id": 27,
    "province_name": "البرز"
  },
  {
    "id": 3,
    "province_name": "ایلام"
  },
  {
    "id": 18,
    "province_name": "بوشهر"
  },
  {
    "id": 25,
    "province_name": "تهران"
  },
  {
    "id": 6,
    "province_name": "چهارمحال و بختیاری"
  },
  {
    "id": 23,
    "province_name": "خراسان جنوبی"
  },
  {
    "id": 22,
    "province_name": "خراسان رضوی"
  },
  {
    "id": 1,
    "province_name": "خراسان شمالی"
  },
  {
    "id": 31,
    "province_name": "خوزستان"
  },
  {
    "id": 11,
    "province_name": "زنجان"
  },
  {
    "id": 12,
    "province_name": "سمنان"
  },
  {
    "id": 24,
    "province_name": "سیستان و بلوچستان"
  },
  {
    "id": 17,
    "province_name": "فارس"
  },
  {
    "id": 9,
    "province_name": "قزوین"
  },
  {
    "id": 26,
    "province_name": "قم"
  },
  {
    "id": 15,
    "province_name": "کردستان"
  },
  {
    "id": 2,
    "province_name": "کرمان"
  },
  {
    "id": 7,
    "province_name": "کرمانشاه"
  },
  {
    "id": 14,
    "province_name": "کهگیلویه و بویراحمد"
  },
  {
    "id": 21,
    "province_name": "گلستان"
  },
  {
    "id": 4,
    "province_name": "لرستان"
  },
  {
    "id": 10,
    "province_name": "گیلان"
  },
  {
    "id": 20,
    "province_name": "مازندران"
  },
  {
    "id": 5,
    "province_name": "مرکزی"
  },
  {
    "id": 30,
    "province_name": "هرمزگان"
  },
  {
    "id": 8,
    "province_name": "همدان"
  },
  {
    "id": 29,
    "province_name": "یزد"
  }
]

const AddContractModal = ({ closeModal, refetchData, editMode }) => {
  const [citySelection, setCitySelection] = useState({
    selected: [],
    unselected: cityList
  })
  const [Users, setUsers] = useState({});
  const [UserName, setUserName] = useState();
  const [IpList, setIpList] = useState([]);
  const [Quota, setQuota] = useState(0);
  const [ApiCall, setApiCall] = useState(0);
  const [ExpireTime, setExpireTime] = useState(new Date());
  const [IpNumber1, setIpNumber1] = useState("");
  const [IpNumber2, setIpNumber2] = useState("");
  const [IpNumber3, setIpNumber3] = useState("");
  const [IpNumber4, setIpNumber4] = useState("");
  const [CreateContractApiState, setCreateContractApiState] = useState({
    res: null,
    loading: null,
  });
  const [EditContractApiState, setEditContractApiState] = useState({
    res: null,
    loading: null,
  });
  
  useEffect(() => {
    if (editMode) {
      setUserName(editMode?.username);
      setIpList(editMode?.ip);
      setQuota(editMode?.quota);
      setApiCall(editMode?.api_call);
      setExpireTime(new Date(editMode?.expire_datetime));

      if (editMode?.allowed_provinces[0] === 1000) {
        setCitySelection({selected : cityList,unselected:[]})
      }else {
        const selectedList = editMode?.allowed_provinces?.map(item=>cityList.find(innerItem => innerItem.id === item))
        
        setCitySelection({
          selected : selectedList,
          unselected:cityList.filter(item => !editMode?.allowed_provinces?.includes(item.id))
        })
      }
      
      
    }
  }, [editMode]);

  useEffect(() => {
    if (EditContractApiState.res) {
      refetchData();
      closeModal();
    }
  }, [EditContractApiState.res]);

  useEffect(() => {
    if (CreateContractApiState.res) {
      refetchData();
      closeModal();
    }
  }, [CreateContractApiState.res]);

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const res = await GetAllUsers({ page: 1, limit: 200 });
        const users = {}
        res.data.data.forEach((item) => (users[item.uuid] = item.username));
        setUsers(users);
      } catch (error) {
        setUsers([]);
      }
    };
    if (!editMode) {
      fetchAllUsers();
    }
  }, []);

  const handleAddIp = () => {
    const ip = IpNumber1 + "." + IpNumber2 + "." + IpNumber3 + "." + IpNumber4;
    setIpNumber1("");
    setIpNumber2("");
    setIpNumber3("");
    setIpNumber4("");
    setIpList((prev) => [...prev, ip]);
  };

  const handleRemoveIp = (index) => {
    const newIpList = [...IpList];
    newIpList.splice(index, 1);
    setIpList(newIpList);
  };

  const handleCreateContract = async () => {
    try {
      setCreateContractApiState({
        res: null,
        loading: true,
      });
      await CreateContract({
        username: UserName,
        ip_list: IpList.length ? IpList : ["0.0.0.0"],
        quota: Quota,
        api_call: ApiCall,
        expire_datetime: ExpireTime.toISOString(),
        allowed_provinces:citySelection?.selected?.length === cityList.length ? [1000]: citySelection.selected?.map(item => item.id)
      });
      setCreateContractApiState({
        res: true,
        loading: false,
      });
      closeModal()
      NotificationManager.success("Created", "Success");
    } catch (error) {
      setCreateContractApiState({
        err: error,
        res: null,
        loading: false,
      });
    }
  };

  const handleEditContract = async () => {
    try {
      setEditContractApiState({
        res: null,
        loading: true,
      });
      await EditContract({
        username: editMode?.username,
        ip_list: IpList.length ? IpList : ["0.0.0.0"],
        quota: Quota,
        api_call: ApiCall,
        expire_datetime: ExpireTime.toISOString(),
        allowed_provinces:citySelection?.selected?.length === cityList.length ? [1000]: citySelection.selected?.map(item => item.id)
      });
      NotificationManager.success("Contracted Updated", "Success");
      setEditContractApiState({
        res: true,
        loading: false,
      });
    } catch (error) {
      setEditContractApiState({
        err: error,
        res: null,
        loading: false,
      });
    }
  };
console.log(citySelection ,"c")
  const handleSwapCity = (swapTo, id) => {
    if (swapTo === "selected") {
      setCitySelection((prev) => {
        return {
          selected: prev.selected.filter(item => item.id !== id),
          unselected: [...prev.unselected, cityList.find(item => item.id === id)]
        }
      })
    } else {
      setCitySelection((prev) => {
        return {
          unselected: prev.unselected.filter(item => item.id !== id),
          selected: [...prev.selected, cityList.find(item => item.id === id)]
        }
      })
    }
  }
  return (
    <div className="flex flex-col items-center gap-3 px-8 py-6 w-[960px] relative">
      <div className="flex items-center w-full gap-4">
        {!editMode && (
          <div className="w-full">
            <Select
              label="User"
              options={Users}
              onChange={(val) => setUserName(val.value)}
              value={UserName}
              readOnly={!!editMode}
            />
          </div>
        )}
        <div className="w-full">
          <Input
            label="Quota"
            onChange={(val) => setQuota(+val)}
            value={Quota}
          />
        </div>
        <div className="w-full">
          <Input
            label="Api Call"
            onChange={(val) => setApiCall(+val)}
            value={ApiCall}
          />
        </div>
      </div>
      <div className="flex items-end w-full gap-4 justify-center">
        <input
          value={IpNumber1}
          onChange={(e) => setIpNumber1(e.target.value)}
          type="number"
          className="border-0 border-b border-gray-box_back px-2 py-1 outline-none text-sm font-semibold w-16 text-center"
          maxLength={3}
        />
        <div className="">.</div>
        <input
          value={IpNumber2}
          onChange={(e) => setIpNumber2(e.target.value)}
          type="number"
          className="border-0 border-b border-gray-box_back px-2 py-1 outline-none text-sm font-semibold w-16 text-center"
          maxLength={3}
        />
        <div className="">.</div>
        <input
          value={IpNumber3}
          onChange={(e) => setIpNumber3(e.target.value)}
          type="number"
          className="border-0 border-b border-gray-box_back px-2 py-1 outline-none text-sm font-semibold w-16 text-center"
          maxLength={3}
        />
        <div className="">.</div>
        <input
          value={IpNumber4}
          onChange={(e) => setIpNumber4(e.target.value)}
          type="number"
          className="border-0 border-b border-gray-box_back px-2 py-1 outline-none text-sm font-semibold w-16 text-center"
          maxLength={3}
        />
        <button
          disabled={!IpNumber1 || !IpNumber2 || !IpNumber3 || !IpNumber4}
          className="px-6 py-3 text-base bg-gray-place_text rounded-sm cursor-pointer disabled:cursor-no-drop disabled:opacity-45"
          onClick={handleAddIp}
        >
          Add Ip
        </button>
      </div>
      <div className="flex items-end w-full gap-4 justify-center">
        <div className="w-full min-h-11 bg-gray-background rounded-sm flex flex-wrap items-center justify-start gap-5 px-3 py-2">
          {IpList.map((item, i) => (
            <div
              key={i}
              className="px-2 py-1 text-sm font-semibold text-blue bg-gray flex justify-center gap-6 rounded-md"
            >
              {item}
              <span
                className="text-white cursor-pointer w-1 h-1 text-center rotate-45 text-lg relative bottom-0.5"
                onClick={() => handleRemoveIp(i)}
              >
                +
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-end w-full gap-4 py-5">
        <div className="w-20 flex items-center text-red-error">
          ExpireTime:
          <DatePicker
            selected={ExpireTime}
            onChange={(date) => setExpireTime(date)}
            className="outline-none ml-3"
          />
          {utcToTime(ExpireTime, "jYYYY/jMM/jDD")}
          {/* <Input
            label="Expire Time"
            onChange={(val) => setQuota(+val)}
            value={Quota}
          /> */}
        </div>
      </div>
      <div className="flex justify-between w-full notSelect ">
        <div>
          <span>unselected citys</span>
          <div className="w-[400px] h-[200px] overflow-y-auto bg-[#f5f8ff] p-3 rounded-lg">
            {citySelection.unselected.map(item => <div dir="rtl" className="flex justify-between cursor-pointer hover:text-blue" onClick={() => handleSwapCity("unselected", item.id)}>
              <span>
                {item.province_name}
              </span>

              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
              </svg>
            </div>)}
            {citySelection.unselected.length === 0 && <div className="flex justify-center items-center h-full w-full">No item avalibale</div>}
          </div>
        </div>
        <div>
          <span>selected citys</span>
          <div className="w-[400px] h-[200px] overflow-y-auto bg-[#f5f8ff] p-3 rounded-lg">
            {citySelection.selected.map(item => <div dir="rtl" className="flex justify-between cursor-pointer hover:text-blue" onClick={() => handleSwapCity("selected", item.id)}>
              <span>{item.province_name}</span>
              <span><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
              </svg>
              </span>
            </div>)}
            {citySelection.selected.length === 0 && <div className="flex justify-center items-center h-full w-full">No item avalibale</div>}
          </div>
        </div>

      </div>
      {!editMode && (
        <button
          disabled={!UserName || CreateContractApiState.loading}
          className="px-3 py-1 m-auto text-center cursor-pointer mt-5 disabled:cursor-no-drop disabled:opacity-30"
          onClick={handleCreateContract}
        >
          Submit
        </button>
      )}
      {editMode && (
        <button
          disabled={!UserName || EditContractApiState.loading}
          className="px-3 py-1 m-auto text-center cursor-pointer mt-5 disabled:cursor-no-drop disabled:opacity-30"
          onClick={handleEditContract}
        >
          Submit
        </button>
      )}
      {(CreateContractApiState.err || EditContractApiState.err) && (
        <div className="absolute bottom-5 right-4 text-sm text-red-error">
          {CreateContractApiState.err?.response?.data?.detail[0]?.msg ||
            CreateContractApiState.err?.response?.data?.detail}
          {EditContractApiState.err?.response?.data?.detail[0]?.msg ||
            EditContractApiState.err?.response?.data?.detail}
        </div>
      )}


    </div>
  );
};

export default AddContractModal;
